const state = {
  online: navigator.onLine
};

const getters = {
  online: state => state.online,
}

const mutations = {
  'SET_CONNECTED': function (state, payload)
  {
    state.online = payload
  },
}

const actions = {
  setConnected: function ({ commit }, payload)
  {
    commit('SET_CONNECTED', payload)
  },
}



export const connection = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
